<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="users"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMappings"
      :refresh-table="getData"
      item-key="id"
      table-height="70vh"
    >     
        <template v-slot:action="{ item }">
          <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="viewItem(item, 'inputer')">
                  <v-list-item-icon>
                    <v-icon>mdi-tune</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Mapping Inputer</v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewItem(item, 'approver')">
                  <v-list-item-icon>
                    <v-icon>mdi-tune</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Mapping Approver</v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewItem(item, 'kode-pos')">
                  <v-list-item-icon>
                    <v-icon>mdi-tune</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Mapping Kode Pos</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </template>
    </TableView>
  </v-card>
</template>

<script>

import mappingWilayahMixin from '../../components/user-management/mapping-wilayah/mappingWilayahMixin';

export default {
  mixins: [mappingWilayahMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>